import { createAction } from 'Lib/reduxUtils';

import {
  POST_PHONE_NUMBER_ERROR,
  POST_PHONE_NUMBER_SUCCESS,
  RESET_POST_PHONE_NUMBER_STATE,
  RESET_VALIDATE_SMS_CODE_STATE,
  SET_OTP_SENDING,
  SET_PHONE_NUMBER,
  SET_PHONE_NUMBER_SENDING,
  SET_SMS_AUTH_STATE,
  SET_SMS_CAPTCHA_REFERENCE_TOKEN,
  SMS_CAPTCHA_COMPLETED,
  SUBMIT_SMS_CAPTCHA_ERROR,
  SUBMIT_SMS_CAPTCHA_SUCCESS,
  VALIDATE_SMS_CODE_ERROR,
  VALIDATE_SMS_CODE_SUCCESS,
} from './constants';

// UI Actions
export const resetValidateSmsCodeState = createAction(RESET_VALIDATE_SMS_CODE_STATE);
export const resetPostPhoneNumberState = createAction(
  RESET_POST_PHONE_NUMBER_STATE,
  ({ clearPhoneNumber = false }: { clearPhoneNumber?: boolean } = {}) => ({ clearPhoneNumber })
);

// UI State
export const postPhoneNumberSuccess = createAction(
  POST_PHONE_NUMBER_SUCCESS,
  (otpLength: number, smsSent: boolean) => ({ otpLength, smsSent })
);
export const postPhoneNumberError = createAction(POST_PHONE_NUMBER_ERROR, (error: any) => ({
  error,
}));
export const submitSMSCaptchaError = createAction(SUBMIT_SMS_CAPTCHA_ERROR, (error: any) => ({
  error,
}));
export const submitSMSCaptchaSuccess = createAction(SUBMIT_SMS_CAPTCHA_SUCCESS, () => {});
export const validateSmsCodeSuccess = createAction(VALIDATE_SMS_CODE_SUCCESS);
export const validateSmsCodeError = createAction(VALIDATE_SMS_CODE_ERROR, (error: any) => ({
  error,
}));
export const setSMSCaptchaReferenceToken = createAction(
  SET_SMS_CAPTCHA_REFERENCE_TOKEN,
  (smsCaptchaReferenceToken: string) => ({
    smsCaptchaReferenceToken,
  })
);
export const smsCaptchaCompleted = createAction(
  SMS_CAPTCHA_COMPLETED,
  (smsCaptchaToken: string) => ({
    smsCaptchaToken,
  })
);
export const setSMSAuthState = createAction(SET_SMS_AUTH_STATE, (smsAuthState: string) => ({
  smsAuthState,
}));

// MFA
export const setPhoneNumber = createAction(SET_PHONE_NUMBER, (phoneNumber: string) => ({
  phoneNumber,
}));
export const setPhoneNumberSending = createAction(SET_PHONE_NUMBER_SENDING);
export const setOtpSending = createAction(SET_OTP_SENDING);
